import cx from 'classnames';
import ChevronLeftIcon from './ChevronLeftIcon';

type TProps = {
  className?: string;
};

export const ChevronRightIcon = ({ className }: TProps) => <ChevronLeftIcon className={cx('rotate-180', className)} />;
